<template>
  <v-dialog
    :value="true"
    persistent
    max-width="500">
    <v-card>
      <v-card-title>
        Import data from link
        <span
          class="sourcery__icon-wrapper black"
          @click="cancel">
          <v-icon
            color="white"
            size="15">
            mdi-close
          </v-icon>
        </span>
      </v-card-title>
      <v-card-text>
        <div
          v-if="isScraping"
          class="d-flex align-center py-4">
          <v-progress-circular
            class="mr-3"
            color="blue"
            indeterminate
            size="24" />
          <span>Importing data from link...</span>
        </div>
        <v-form
          v-else
          @submit.prevent="accept">
          <v-text-field
            ref="importLinkInput"
            v-model.trim="importLinkUrl"
            :error-messages="importLinkUrlErrorMessages"
            placeholder="URL"
            single-line
            dense
            autofocus
            @input="importLinkUrlTouched = true" />
        </v-form>
        <p
          v-if="scrapeErrorMessage"
          class="red--text small-p mb-0">
          {{ scrapeErrorMessage }}
        </p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          outlined
          @click="cancel">
          Cancel
        </v-btn>
        <v-btn
          v-if="!isScraping"
          color="blue"
          class="white--text"
          @click="accept">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import ErrorsText from '@/constants/errors';
import RequestAbortController from '@/utils/RequestAbortController';

export default {
  name: 'TableImportLinkDialog',
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    abortController: null,
    importLinkUrl: '',
    importLinkUrlTouched: false,
    isResolved: false,
    isScraping: false,
    scrapeErrorMessage: '',
  }),
  computed: {
    importLinkUrlErrorMessages() {
      if (!this.importLinkUrlTouched) return [];
      if (!this.importLinkUrl) return [ErrorsText.ENTER_REQUIRED_VALUE];
      if (!this.isValidUrl(this.importLinkUrl)) return [ErrorsText.ERROR_VALID_URL];
      return [];
    },
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.importLinkInput?.focus();
  },
  beforeDestroy() {
    if (this.isScraping) {
      this.abortScrape('Import link dialog closed');
    }
  },
  methods: {
    ...mapActions({
      scrapeProductData: 'Collections/scrapeProductData',
    }),
    async accept() {
      this.importLinkUrlTouched = true;
      this.scrapeErrorMessage = '';
      if (!this.importLinkUrl || !this.isValidUrl(this.importLinkUrl)) return;
      this.isScraping = true;
      this.abortController = new RequestAbortController();
      try {
        const scrapedProduct = await this.scrapeProductData({
          url: this.importLinkUrl,
          abortController: this.abortController,
        });
        if (this.abortController?.aborted()) return;
        this.resolve(scrapedProduct);
      } catch (err) {
        if (this.abortController?.aborted()) return;
        console.error('Error in web scraping product data', err);
        this.scrapeErrorMessage = 'Sorry, but we could not import this product.';
      } finally {
        this.isScraping = false;
        this.abortController = null;
      }
    },
    cancel() {
      if (this.isScraping) {
        this.abortScrape('Import link scrape cancelled');
      }
      this.resolve(null);
    },
    abortScrape(message) {
      this.abortController?.abort({
        message,
      });
    },
    resolve(value) {
      if (this.isResolved) return;
      this.isResolved = true;
      this.$emit('resolve', value);
    },
    isValidUrl(val) {
      if (!val) return true;
      // eslint-disable-next-line
      const regexArr = val?.match(/^(?:(?:http|ftp)s?:\/\/)?(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,6}\.?|[a-zA-Z0-9-]{2,}\.?)|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/);
      return regexArr?.length;
    },
  },
};
</script>
